import { createRef, Ref } from '@wix/materializer'
import { InternalRefDataItem, pointers, ViewMode, WidgetRefDataItem } from '@wix/thunderbolt-becky-types'
import { removeHash } from '@wix/thunderbolt-catharsis'
import { getRefTemplateKey, isRefComponent, isSharedPart as isSharedPartUtil } from '../../byRefUtils'
import { createByRefsisCompNode } from '../../compNodeUtils'
import { ENVIRONMENT_NAMESPACE, SITE_NAMESPACE } from '../../constants'

type Dependencies = { refCompData: Ref<WidgetRefDataItem | InternalRefDataItem>; viewMode: Ref<ViewMode> } | undefined
type ViewItem = { templateKey: string; rootCompId: string; isSharedPart: boolean; pageId?: string } | null

const {
	data: {
		DATA_MAPS: { DATA },
	},
} = pointers

export const RefComponentsTemplateData = createByRefsisCompNode<Dependencies, ViewItem>({
	getDependencies: (__, component, scopedCreateRef) =>
		isRefComponent(component)
			? {
					refCompData: scopedCreateRef(DATA, removeHash(component.dataQuery!)) as Ref<WidgetRefDataItem>,
					viewMode: createRef<ViewMode>([ENVIRONMENT_NAMESPACE, ENVIRONMENT_NAMESPACE, 'viewMode']),
			  }
			: undefined,
	toViewItem: (__, dependencies) => {
		if (!dependencies) {
			return null
		}

		const { refCompData, viewMode } = dependencies
		const { rootCompId, pageId } = refCompData as InternalRefDataItem

		const isInternalRef = refCompData.type === 'InternalRef'
		const isSharedPart = isInternalRef && isSharedPartUtil(refCompData)
		const templateKey = isInternalRef ? SITE_NAMESPACE : getRefTemplateKey(refCompData, viewMode)

		return {
			templateKey,
			isSharedPart,
			rootCompId,
			pageId: isSharedPart ? 'masterPage' : pageId,
		}
	},
})
